// extracted by mini-css-extract-plugin
export default {"button":"Buttons__button--3Pr","demo":"Buttons__demo--3-Z","play":"Buttons__play--3Cy"};